import { render, staticRenderFns } from "./AllBusinessCasesUngrouped.vue?vue&type=template&id=2cfc905a&scoped=true&"
import script from "./AllBusinessCasesUngrouped.vue?vue&type=script&lang=js&"
export * from "./AllBusinessCasesUngrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc905a",
  null
  
)

export default component.exports